module.exports = __webpack_public_path__ + "static/illustrationAmbiance-466ff25cc641db95da947cc4c93ebec3.svg";